import { signInWithEmailAndPassword, updatePassword } from "firebase/auth";
import {
  initFirebase,
  clearFirebaseLocalStorage,
} from "@shared/services/api/firebase";

export type Args = {
  email: string;
  oldPassword: string;
  newPassword: string;
};

export async function updateUserPassword({
  email,
  oldPassword,
  newPassword,
}: Args) {
  try {
    const auth = await initFirebase();

    // Re-authenticate the user with the old password
    const userCredential = await signInWithEmailAndPassword(
      auth,
      email,
      oldPassword
    );

    const user = userCredential.user;

    // Update the password to the new one
    await updatePassword(user, newPassword);

    await user?.reload();

    return user;
  } catch (error) {
    clearFirebaseLocalStorage();

    throw error;
  }
}

export default updateUserPassword;
